<script>
export default {
    props: {
        showDaysTillEndOfSubscription: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    mounted() {
        $(() => {
            apply_stickies()

            window.addEventListener('scroll', function() {
                apply_stickies()
            })
        })
    }
}
</script>
